import axios from "axios";

var API = "https://search.grants.nih.gov/faq/api/";

// Loads a particular FAQ
export async function fetchSubjectAreaDetails(areaID) {
   try {
      const response = await axios.get(API + "faq/" + areaID);
      return response.data.data;
   } catch (error) {
      console.error(error);
   }
}

// Loads a list of subjects by accessing their parent category ID
export async function fetchCategory(catID) {
   try {
      const response = await axios.get(API + "subjects_in_category/" + catID);
      return response.data.message;
   } catch (error) {
      console.error(error);
   }
}

// Loads the questions and answers and related data. Used for search purposes.
export async function searchFAQcontent(query) {
   //await setapi();
   const { data } = await axios.get(API + "search/question/" + query);
   return data;
}

// Loads the featured questions for a particular subject area
export async function fetchFeaturedQuestions(catID) {
   //await setapi();
   const { data } = await axios.get(API + "featured_questions/" + catID);
   return data;
}
